export interface Bonus {
  label: string
  title: string
  description: string
  items?: string[]
  outcome: string
  value: string
  image: string
}

export const bonuses: Bonus[] = [
  {
    label: 'BONUS #1',
    title: 'ALIGNER QUICK COMMAND CARDS™',
    description: 'A collection of visual cards covering the major stages of the aligner workflow.',
    items: [
      'Case Assessment',
      'Planning',
      'Installation',
      'Attachments',
      'IPR',
      'Follow-Up',
      'Reassessment',
      'Refinement',
      'Finishing',
    ],
    outcome: 'Find the relevant workflow without opening the entire system.',
    value: '$37',
    image: 'https://cdn.magicpatterns.com/uploads/2DfXqXJLW7QNJYsu3bB3c8/BONUS_1_CASE-EN.png',
  },
  {
    label: 'BONUS #2',
    title: 'CASE TIMELINE TRACKER™',
    description: 'A complete visual tracking system for organizing the history of an aligner case.',
    items: [
      'Case Timeline',
      'Appointment Tracker',
      'Progress Tracker',
      'Documentation Tracker',
      'Case Status',
      'Review History',
    ],
    outcome: 'See the story of the case on one organized timeline.',
    value: '$37',
    image: 'https://cdn.magicpatterns.com/uploads/i7gaDCRaegE9pwpT3NEciq/BONUS_2_CASE-EN.png',
  },
  {
    label: 'BONUS #3',
    title: 'PRE-INSTALLATION COMMAND CHECKLIST™',
    description:
      'A structured preparation checklist designed to help organize the key points you want to review before an installation appointment.',
    outcome: 'Replace scattered preparation with one repeatable workflow.',
    value: '$27',
    image: 'https://cdn.magicpatterns.com/uploads/dZtehSKit1jWLvf87zyi4M/BONUS_3_CASE-EN.png',
  },
  {
    label: 'BONUS #4',
    title: 'REFINEMENT CASE REVIEW KIT™',
    description:
      'A dedicated collection of organizational tools for cases that require reassessment and potential refinement planning.',
    items: [
      'Case Review Sheet',
      'Reassessment Checklist',
      'Documentation Sheet',
      'Review Questions',
      'Refinement Planning Organizer',
    ],
    outcome: 'Reconstruct the case visually instead of starting from zero.',
    value: '$37',
    image: 'https://cdn.magicpatterns.com/uploads/hgfBmviCtpu64CBrR9YHgP/BONUS_4_CASE-EN.png',
  },
  {
    label: 'BONUS #5',
    title: 'ALIGNER DESK COMMAND CENTER™',
    description: 'Turn your workspace into a visual control center.',
    items: [
      'Treatment Journey Poster',
      'Master Workflow',
      'Case Control Map',
      'Installation Card',
      'Progress Card',
      'Review Card',
      'Refinement Card',
      'Finishing Card',
    ],
    outcome: 'Keep your most-used workflow tools within visual reach.',
    value: '$39',
    image: 'https://cdn.magicpatterns.com/uploads/36myN68d2jFABoC6xeso2s/BONUS_5_CASE-EN.png',
  },
]
